import { render } from "./ScrollUp.vue?vue&type=template&id=27a73fb4&scoped=true"
import script from "./ScrollUp.vue?vue&type=script&lang=js"
export * from "./ScrollUp.vue?vue&type=script&lang=js"

import "./ScrollUp.vue?vue&type=style&index=0&id=27a73fb4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a73fb4"]])

export default __exports__